import { MtxGrid } from '@meilleurtaux/mtp-uikit-react';
import { useTranslation } from 'react-i18next';

import { Allocation } from '@/components/Allocation/Allocation';
import { SummaryArbitrage } from '@/components/SummaryArbitrage/SummaryArbitrage';

import styles from './styles.module.css';

interface AllocationAnalysisProps {
  currentScore: number;
  newScore: number;
  currentProfile: string;
  newProfile: string;
  contractName: string;
  totalReinvested: number;
  totalFees: number;
}

const AllocationAnalysis: React.FC<AllocationAnalysisProps> = ({
  currentScore,
  newScore,
  currentProfile,
  newProfile,
  contractName,
  totalReinvested,
  totalFees,
}) => {
  const { t } = useTranslation();
  return (
    <div className={styles.allocationAnalysis}>
      <h2 className={styles.allocationAnalysisTitle}>{t('allocationAnalysis.title')}</h2>

      <MtxGrid className={styles.container} row>
        <MtxGrid col={6} colXs={12} colSm={8} colMd={6} colLg={6}>
          <Allocation
            currentScore={currentScore}
            newScore={newScore}
            currentProfile={currentProfile}
            newProfile={newProfile}
          />
        </MtxGrid>

        <MtxGrid col={6} colXs={12} colSm={4} colMd={4} colLg={4}>
          <SummaryArbitrage contractName={contractName} totalReinvested={totalReinvested} totalFees={totalFees} />
        </MtxGrid>
      </MtxGrid>
    </div>
  );
};

export { AllocationAnalysis };
